import { MDBBtn,MDBIcon } from 'mdbreact';
import React, { useState, useEffect } from 'react';
import { Card, CardBody, Col, Collapse, Container, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, Label, Media, Row } from "reactstrap";
import SolicitudComponente from '../../components/solicitud/SolicitudComponente';

const ModalSolicitud = props => {
    const [sideAbierto, setSide] = useState(false);

    const changeSideAbierto = () => {
        setSide(current => !current);
    };

    useEffect(() => {
        const close = (e) => {
            if(e.key === 'Escape'){
                setSide(false);
            }
        }
        window.addEventListener('keydown', close)      
    },[])
    
    const closeBtn = (
        <MDBBtn className="waves-effect" color="danger" onClick={changeSideAbierto} >
            <MDBIcon icon="fas fa-arrow-left"/>
            {' '}
            Regresar
        </MDBBtn>
    );

    return (
        <div>
            <MDBBtn className="waves-effect" display="none" size="sm" color={props.color} title={props.titulo} onClick={changeSideAbierto}>
                <MDBIcon icon={props.icon} />
            </MDBBtn>            
            <Modal isOpen={sideAbierto} size="xl">
                <ModalHeader close={closeBtn}>{props.titulo}</ModalHeader>
                &nbsp;
                <Row className="scrollableY">
                    <SolicitudComponente idRegistro={props.idRegistro} rol={props.rol} titulo={props.titulo} actualizarFila={props.actualizarFila} changeSideAbierto={changeSideAbierto}/>
                </Row>
                <ModalFooter>
                    {closeBtn}
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default ModalSolicitud;